<template>
  <div class="system-simulation-payment">
    <p style="color: red;white-space:pre-line">{{ $t('system.simulation_warning') }}</p>
    <el-card class="box-card">
      <div class="text item">
        <el-form ref="form" :model="search" label-width="150px" :rules="rules" label-position="left">
          <el-form-item :label="$t('system.mch_order_id')" prop="mch_order_id" required>
            <el-input v-model="search.mch_order_id" size="small" :placeholder="$t('system.mch_order_id')" class="search-frame" autocomplete="off" clearable />
          </el-form-item>
          <el-form-item :label="$t('system.amount')" prop="amount" required>
            <el-input v-model="search.amount" size="small" :placeholder="$t('system.amount')" class="search-frame" autocomplete="off" clearable />
            <span style="font-size: small">{{ $store.getters.isID ? $t('system.payment_amount_tips_id', { currency: $store.getters.currency }) : $t('system.payment_amount_tips', { currency: $store.getters.currency }) }}</span>
          </el-form-item>
          <el-form-item :label="$t('system.channel_code')" prop="channel_code" required>
            <el-input v-model="search.channel_code" size="small" :placeholder="$t('system.channel_code')" class="search-frame" autocomplete="off" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="listLoading" @click="onSubmit('form')">Submit</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { simulationStaticPayment } from '@/api/develop-manage/develop-manage'
export default {
  name: 'System_simulation_payment',
  data() {
    const checkAmount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('amount is required'))
      }
      return callback()
    }
    return {
      listLoading: false,
      search: {
        mch_order_id: '',
        amount: 0,
        channel_code: ''
      },
      rules: {
        amount: [
          { validator: checkAmount, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  mounted() {

  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.listLoading = true
          simulationStaticPayment(this.search).then(res => {
            if (res.code === 10000) {
              this.$message.success('Success')
              this.search.amount = 0
            }
          }).finally(() => {
            this.listLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .system-simulation-payment{
    margin: 20px;
    background-color: #fff;
  }
</style>
